const translations = {
  passed: '\u2713',
  failed: '\u2012',
};

export default translations;
